// DEPRECATED(formsy-retirement): legacy formsy-react field. Use a Formik-based field instead.
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import React from 'react';

const defaultStyle = {
  padding: '3px 7px',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--border-default)',
  borderTopColor: 'var(--border-default)',
  width: '100%',
  fontSize: '14px',
  backgroundColor: 'var(--surface-primary)',
  backgroundImage: 'none',
  backgroundClip: 'padding-box',
  color: 'var(--text-primary)',
  lineHeight: 1.25,
};

class MinimalTextArea extends React.Component {
  constructor(props) {
    super(props);
  }

  changeValue = event => {
    const { setValue, passValue } = this.props;
    // get value
    const { value } = event.currentTarget;
    // set Formsy value
    setValue(value);
    // if custom passValue function is passed, give that the value too
    if (typeof passValue === 'function') {
      passValue(value);
    }
  };

  render() {
    const {
      helpText,
      title,
      name,
      errorMessage,
      showRequired,
      error, // manually passed in error.
      value,
      inputProps,
      outerProps,
      style,
    } = this.props;

    const combinedStyle = _.defaults(style, defaultStyle);

    // errorMessage, showRequired, and error
    let errorText = '';
    if (errorMessage) {
      errorText = errorMessage;
    } else if (error) {
      errorText = error;
    } else if (showRequired) {
      errorText = 'This Field is Required';
    }

    return (
      <div {...outerProps}>
        <textarea
          name={name}
          // errorText={errorText}
          onChange={this.changeValue}
          value={value}
          style={combinedStyle}
          {...inputProps}
        />
        {errorText && <div style={{ color: 'var(--md-error)' }}>{errorText}</div>}
      </div>
    );
  }
}

export default withFormsy(MinimalTextArea);
